import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Download } from "lucide-react";
import { SITE } from "../../data";

export default function CartaResponsabilidad() {
  return (
    <section id="carta" className="relative bg-[#111827] text-white py-20 lg:py-28 overflow-hidden">
      <div className="grain-overlay" />
      <div className="absolute top-0 left-0 h-1.5 w-full flex">
        <span className="flex-1 bg-espana-red" />
        <span className="flex-1 bg-espana-gold" />
        <span className="flex-1 bg-espana-red" />
      </div>

      <div className="relative max-w-5xl mx-auto px-5 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="inline-flex items-center gap-2 mb-6 text-xs font-bold uppercase tracking-[0.25em] text-espana-gold"
        >
          <ShieldCheck size={16} /> Un compromiso que ningún partido ha firmado antes
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.05 }}
          className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-none"
        >
          Quien incumple, <span className="text-espana-red bg-white px-3">dimite.</span>
          <br />
          <span className="text-white/60 text-2xl sm:text-3xl font-bold tracking-tight">
            Sin excusas. Sin excepciones.
          </span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="mt-8 text-lg text-white/70 max-w-2xl mx-auto leading-relaxed"
        >
          De acuerdo con los artículos 1.2, 9.2, 40.1 y 128.1 de la Constitución
          Española, E² exige a sus representantes un compromiso de responsabilidad
          superior al establecido por la ley.
        </motion.p>

        <div className="mt-6 flex flex-wrap justify-center gap-2 text-sm font-bold uppercase tracking-widest text-white/50">
          <span>Responsabilidad</span><span className="text-espana-gold">·</span>
          <span>Transparencia</span><span className="text-espana-gold">·</span>
          <span>Servicio</span><span className="text-espana-gold">·</span>
          <span>Ejemplaridad</span>
        </div>

        <a
          href={SITE.cartaPdf}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="carta-download-btn"
          className="mt-10 inline-flex items-center gap-2 bg-espana-red hover:bg-espana-reddark text-white font-bold px-7 py-4 rounded-sm transition-colors"
        >
          <Download size={18} /> Descargar la Carta de Responsabilidad
        </a>
        <p className="mt-4 text-sm text-white/40 italic">
          La confianza no se exige, se gana mediante hechos, transparencia y resultados.
        </p>
      </div>
    </section>
  );
}
